module.exports = __webpack_public_path__ + "img/sale-hellepaivat.34ef4da3.jpeg";